import { Card, CardContent, CardHeader } from '@/components/ui/card'
import { cn } from '@/lib/tailwind.utils'
import { accentLevelBgMap } from '../types'
import type { AccentColor, CapabilityLevel } from '../types'

interface CapabilityLevelCardProps {
  level: CapabilityLevel
  accentColor: AccentColor
  index: number
  isFirst?: boolean
  isLast?: boolean
}

const CapabilityLevelCard = ({
  level,
  accentColor,
  index,
  isFirst,
  isLast,
}: CapabilityLevelCardProps) => {
  const bgStyle = accentLevelBgMap[accentColor][index]

  return (
    <Card
      className={cn(
        'h-full rounded-none border-0 shadow-none',
        isFirst && 'rounded-l-lg',
        isLast && 'rounded-r-lg',
        bgStyle,
      )}
    >
      <CardHeader className="gap-2 pb-2">
        <span className="text-xs font-semibold uppercase tracking-[0.2em] text-foreground/60">
          Level {level.level}
        </span>
        <p className="line-clamp-2 text-sm font-semibold leading-tight text-foreground">
          {level.title}
        </p>
      </CardHeader>
      <CardContent>
        <p className="line-clamp-4 text-sm leading-relaxed text-foreground/70">
          {level.description}
        </p>
      </CardContent>
    </Card>
  )
}

export default CapabilityLevelCard
